<template lang="pug">
  app-toolbar(:title="`Дело № ${ caseNumber }`")
    app-toolbar-item(v-if="canShowGroupActions" :items="actions" @select="dispatchDocAction") Применить к показанному
    app-toolbar-item.ml-6(v-if="!isLimitView" label="Показать" :items="predicates" min-width="216" @select="updatePredicate") {{ currentPredicate || currentPredicateAll }}
    app-toolbar-item.ml-6(label="Сессия" :items="sessions" key-name="name" @select="selectSession") {{ currentSession.name }}

    app-dialog-confirm(v-model="sendConfirm" confirm-button="Отправить" @confirm="sendAllVisibleDocs") 
      | Отправить выбранные документы ({{ documents.length }} шт.)?
    
    app-dialog-confirm(v-model="deleteConfirm" confirm-button="Удалить" @confirm="deleteAllVisibleDocs") 
      | Удалить выбранные документы ({{ documents.length }} шт.)?

    app-dialog-loading(v-model="updating")
</template>

<script>
const action = {
  send: 'Отправить',
  open: 'Редактировать',
  delete: 'Удалить'
}

const display = {
  all: 'Все',
  subpoena: 'Повестки',
  definition: 'Определения',
  request: 'Запросы',
  template: 'Шаблонные документы',
  extra: 'Дополнительные материалы',
  forSign: 'На подпись',
  forSend: 'Готовые для отправки',
  delivered: 'Доставленные',
  received: 'Получен ответ'
}

let groupStatuses = ['SIGNREQUIRED', 'NOTSENDED', 'NOTDELIVERED', 'RETURNED']

import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
import { AppDialogConfirm, AppDialogLoading } from '@/components'

export default {
  props: {
    isLimitView: Boolean
  },

  components: {
    [AppDialogConfirm.name]: AppDialogConfirm,
    [AppDialogLoading.name]: AppDialogLoading
  },

  data () {
    return {
      actions: [action.send, action.open, action.delete],
      deleteConfirm: false,
      sendConfirm: false,
      currentPredicateAll: display.all,
      predicates: [
        display.all, 
        display.forSign, display.forSend, display.delivered, display.received
      ]
    }
  },

  computed: {
    ...mapState('courtCase', ['sessionIndex', 'updating','currentPredicate']),
    ...mapGetters('courtCase', ['caseNumber', 'sessions', 'documents', 'currentSession']),

    canShowGroupActions () {
      let list = this.documents.filter(d => groupStatuses.includes(d.deliveryStatus.name))
      return list.length > 0 && list.length == this.documents.length
    }
  },

  methods: {
    ...mapMutations('courtCase', ['setSessionIndex', 'setPredicate', 'setCurrentPredicate']),
    ...mapActions('courtCase', ['sendVisibleDocuments', 'deleteVisibleDocuments']),

    selectSession (session, index) {
      this.setSessionIndex(index)
    },

    updatePredicate (predicate, index) {
      switch (predicate) {
        case display.all: { this.setPredicate(null); break; }
        case display.forSign: { this.setPredicate(d => d.deliveryStatus.name == 'SIGNREQUIRED'); break; }
        case display.forSend: { this.setPredicate(d => d.deliveryStatus.name == 'NOTSENDED'); break; }
        case display.delivered: { this.setPredicate(d => d.deliveryStatus.name == 'DELIVERED'); break; }
        case display.received: { this.setPredicate(d => d.deliveryStatus.name == 'RECEIVED'); break; }
        default: {
          this.$root.$emit('dev')
          console.log('updatePredicate', predicate, index)
          return
        }
      }
      this.setCurrentPredicate(predicate)
      this.currentPredicate = predicate
    },

    dispatchDocAction (docAction) {
      switch (docAction) {
        case action.open: { this.openAllVisibleDocs(); break; }
        case action.send: { this.sendConfirm = true; break; }
        case action.delete: { this.deleteConfirm = true; break; }
      }
    },

    openAllVisibleDocs() {
      this.documents.forEach(({ sendable }) => {
        if (sendable && sendable.result) {
          let link="ms-word:ofe|u|"+document.location.origin+sendable.result
          window.open(link, '_blank')
        }
      })
    },

    sendAllVisibleDocs() {
      this.sendConfirm = false
      this.sendVisibleDocuments()
    },

    deleteAllVisibleDocs() {
      this.deleteConfirm = false
      this.deleteVisibleDocuments()
    },
  }
}
</script>
